'use client';

import { useEffect, useState } from 'react';
import HeroSection from './HeroSection';
import ProgramOverview from './ProgramOverview';
import WhatWeGrow from './WhatWeGrow';
import CurriculumTimeline from './CurriculumTimeline';
import PhotoGallery from './PhotoGallery';
import StudentOutcomes from './StudentOutcomes';

interface School {
  id: number;
  schoolName: string;
  location: string;
  image: string;
  alt: string;
  studentsReached: number;
  poundsGrown: number;
  programYear: string;
  testimonial: string;
  teacherName: string;
}

const FarmOfThoughtInteractive = () => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const schools: School[] = [
    {
      id: 1,
      schoolName: 'HD Woodson High School',
      location: 'Washington, DC',
      image: "/assets/images/Screenshot_2026-02-01_at_10.24.52_AM-1769959498425.png",
      alt: 'HD Woodson High School modern building exterior with glass windows and landscaped grounds',
      studentsReached: 60,
      poundsGrown: 0,
      programYear: '2022-2023',
      testimonial: 'HD Woodson was home to our first two pilot programs. We tested the agricultural technology curriculum twice here, with the founder teaching the program directly. No vertical farm was placed, but the curriculum laid the foundation for all future programs. Students showed incredible enthusiasm for learning sustainable agriculture and technology.',
      teacherName: 'Founder-Led Program'
    },
    {
      id: 2,
      schoolName: 'KIPP DC Legacy College Prep',
      location: 'Washington, DC',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_10678a202-1769277588077.png",
      alt: 'KIPP DC Legacy College Prep school building with vibrant learning environment',
      studentsReached: 45,
      poundsGrown: 250,
      programYear: '2023-2024',
      testimonial: 'Our first paid pilot program! We placed a Gardyn vertical farm at KIPP DC and paid a teacher to facilitate the program in an afterschool club, meeting once a week. Students engaged deeply with both the technology and the hands-on growing experience, producing fresh food for their community.',
      teacherName: 'KIPP DC Afterschool Facilitator'
    },
    {
      id: 3,
      schoolName: 'Montessori School of NC',
      location: 'North Carolina',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1a9ff324a-1769277586526.png",
      alt: 'Montessori School of NC campus with hands-on learning spaces',
      studentsReached: 35,
      poundsGrown: 180,
      programYear: '2024-2025',
      testimonial: 'We sent the Gardyn vertical farm and complete curriculum to Montessori School of NC, with a teacher facilitating the program on-site. The hands-on nature of hydroponics aligns perfectly with Montessori philosophy. We are awaiting detailed feedback from the teacher.',
      teacherName: 'Montessori Facilitator'
    },
    {
      id: 4,
      schoolName: 'Ron Brown College Preparatory High School',
      location: 'Washington, DC',
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_176cea613-1766740358377.png",
      alt: 'Ron Brown College Preparatory High School modern campus facility',
      studentsReached: 0,
      poundsGrown: 0,
      programYear: 'Starting January 28, 2026',
      testimonial: 'We are excited to launch our program at Ron Brown College Prep on January 28th! The teacher will be facilitating the program, and we have already sent a Gardyn vertical farm to the school. This partnership represents our continued growth and commitment to bringing innovative agricultural technology education to DC students.',
      teacherName: 'Ron Brown Prep - Upcoming Program'
    }
  ];

  if (!isHydrated) {
    return (
      <div className="min-h-screen bg-background">
        <div className="h-[700px] bg-surface animate-pulse" />
        <div className="max-w-7xl mx-auto px-4 py-20">
          <div className="h-64 bg-surface rounded-xl animate-pulse mb-8" />
          <div className="h-96 bg-surface rounded-xl animate-pulse" />
        </div>
      </div>
    );
  }

  return (
    <>
      <HeroSection />
      <ProgramOverview />
      <WhatWeGrow />
      <CurriculumTimeline />
      <PhotoGallery />
      <StudentOutcomes />
    </>
  );
};

export default FarmOfThoughtInteractive;